import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { dateFormats } from "@sinecycle/growcomponents";

interface ShowOpenStatusProps {
  date: string;
}

function ShowOpenStatus(props: ShowOpenStatusProps) {
  const { date: dueDate } = props;
  const currentDate = dateFormats.dayJS();
  const formattedDueDate = dateFormats.dayJS(dueDate);
  const days = currentDate.diff(formattedDueDate, "days");
  return (
    <TypographyText fs={"12"} style={{ color: "var(--red-7)" }}>
      {days === 1
        ? `Open for ${Math.abs(days)} day`
        : days > 1
        ? `Open for ${Math.abs(days)} days`
        : "Opened today"}
    </TypographyText>
  );
}

export { ShowOpenStatus };
